import { useEffect, useState } from 'react';

/**
 * Devuelve el valor después de que pase `delay` ms sin cambios.
 * Se usa para evitar disparar requests en cada tecla del input de búsqueda.
 */
export function useDebounce<T>(value: T, delay: number = 300): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}